export default {

  state: {
    loadingServiceAreas: true,
  },

  mutations: {

    LOADING_SERVICE_AREAS(state, payload) {
      state.loadingServiceAreas = payload;
    },

  },

  getters: {

    useWizardPreferences(state, getters, rootState) {
      return rootState.route.query.referrer === 'wizard-offerings';
    },

  },

};
